import React from 'react';
import { connect } from 'react-redux';
import { removeWarehouseReceiveingOrder } from '../../redux/actions/warehouseReceivingOrders';

import { Modal, Text } from '@bigcommerce/big-design';

const RemoveWroDialog = ({ payload, setShowRemoveWroDialog, showRemoveWroDialog, wroId, removeWro }) => {
  const confirmRemoval = () => {
    removeWro(payload, wroId);
    setShowRemoveWroDialog(false);
  }

  return(
    <Modal
      actions={[
        {
          text: 'Cancel',
          variant: 'subtle',
          onClick: () => setShowRemoveWroDialog(false),
        },
        { 
          text: 'Remove Print', 
          onClick: () => confirmRemoval()
        },
      ]}
      closeOnClickOutside={true}
      closeOnEscKey={true}
      header="Remove Warehouse Receiving Order Print"
      isOpen={showRemoveWroDialog}
      onClose={() => setShowRemoveWroDialog(false)}
    >
      <Text>
        Confirm removal of this warehouse receiving order print.
      </Text>
    </Modal>
  )
}

const mapStateToProps = state => ({

});

const mapDispatchToProps = (dispatch) => ({
  removeWro: (payload, wroId) => dispatch(removeWarehouseReceiveingOrder(payload, wroId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RemoveWroDialog);
